export default __webpack_public_path__ + "static/media/sidebar-1.0f598b51.png";